import { render, staticRenderFns } from "./MediaModulMasonryLayout.vue?vue&type=template&id=5809b0aa&scoped=true&"
import script from "./MediaModulMasonryLayout.vue?vue&type=script&lang=js&"
export * from "./MediaModulMasonryLayout.vue?vue&type=script&lang=js&"
import style0 from "./MediaModulMasonryLayout.vue?vue&type=style&index=0&id=5809b0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809b0aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBadge,VCard,VCardSubtitle,VCardText,VCardTitle,VChip,VIcon,VImg})
